import * as React from "react";
import {createRoot, type Root} from "react-dom/client";
import {
	FixedBreakConfigurationPanel
} from "@/features/admin/breakModel/fixedBreakConfigurationPanel";
import type {FixedBreakConfiguration} from "@/features/admin/breakModel/fixedBreakConfigurationPanel";
import type {FieldError} from "@/shared/timr";

export type {FixedBreakConfiguration};

export interface FixedBreakConfigurationPanelBridgeConfig {
	container: HTMLElement | null;
	onChange: (configuration: FixedBreakConfiguration) => void;
}

export class FixedBreakConfigurationPanelBridge {
	private readonly root: Root;
	private destroyed = false;

	constructor(private readonly config: FixedBreakConfigurationPanelBridgeConfig) {
		if (!config.container) {
			throw new Error("Fixed break configuration panel container is missing");
		}
		this.root = createRoot(config.container, {
			identifierPrefix: "fixed-break-configuration-panel-"
		});
	}

	public update(configuration: FixedBreakConfiguration, fixedBreakFieldErrors: FieldError[] = []) {
		if (this.destroyed) return;
		this.root.render(
			<FixedBreakConfigurationPanel
				configuration={configuration}
				fieldErrors={fixedBreakFieldErrors}
				onChange={this.config.onChange}
			/>
		);
	}

	public destroy() {
		if (this.destroyed) return;
		this.root.unmount();
		this.destroyed = true;
	}
}
